import { observer } from 'mobx-react'

import { SelectField } from '@avantstay/backoffice-core'

import * as S from './AsyncHotelFilter.styles'
import { AsyncHotelFilterProps } from './AsyncHotelFilter.types'
import { asyncHotelFilterStore } from './stores/AsyncHotelFilterStore'

const _AsyncHotelFilterSelect = ({ initialValue, onChange }: AsyncHotelFilterProps) => {
  const { hotelOptions, isLoading } = asyncHotelFilterStore

  const value = hotelOptions.find(hotelOption => hotelOption.value === initialValue)

  return (
    <S.SelectWrapper>
      <SelectField.Small
        menuPosition="fixed"
        placeholder="Select a hotel"
        options={hotelOptions}
        value={value}
        isLoading={isLoading}
        onChange={props => onChange(props.value)}
      />
    </S.SelectWrapper>
  )
}

export const AsyncHotelFilterSelect = observer(_AsyncHotelFilterSelect)
